<template>
    <div>
        <h1 class="display-heading">Consultation Session</h1>

        <ul class="nav nav-tabs nav-tabs-nowrap" id="myTab" role="tablist">
            <li class="nav-item">
                <a
                    class="nav-link active"
                    id="consultation-details-tab"
                    data-toggle="tab"
                    href="#consultationDetails"
                    role="tab"
                >Consultation Details</a>
            </li>
            <li v-if="shouldShowCovid19Form" class="nav-item">
                <a
                    class="nav-link"
                    id="consultation-covid19-tab"
                    data-toggle="tab"
                    href="#covid19Questionnaire"
                    role="tab"
                >
                    <span class="text-primary" style="font-weight: bold;">Covid-19 Questionnaire</span>
                </a>
            </li>
        </ul>

        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="consultationDetails" role="tabpanel">
                <div class="tab-content-wrapper">
                    <div class="card mb-5">
                        <div class="card-body">
                            <appointment-detail
                                participantNameDisplay="Doctor Name"
                                :isConsultation="true"
                                :consultationId="consultation.consultationId"
                                :appointmentDate="consultation.startTime"
                                :appointmentParticipant="consultation.doctorName"
                                :doctorClinicHospitalName="consultation.doctorHospitalOrClinic"
                                :isPatient="true"
                            ></appointment-detail>
                        </div>
                    </div>

                    <div v-if="consultationStatus===2">
                        <div class="mb-3">
                            <twilio-video
                                ref="twilioVideo"
                                :twilioToken="this.twilioToken"
                                :twilioRoomName="this.twilioRoomName"
                                :loading.sync="isTwilioLoading"
                                :started.sync="isTwilioStarted"
                                :joined.sync="isTwilioJoined"
                                :statusText.sync="twilioStatus"
                                :startText="startVideoText"
                                :waitingText="waitingVideoText"
                                :isEnded.sync="isVideoCallEnded"
                            >
                                <p v-if="twilioStatus">{{twilioStatus}}</p>
                                <button
                                    v-show="!isTwilioStarted"
                                    class="btn btn-primary btn-primary-insv"
                                    @click="startVideoCall"
                                >
                                    Join
                                    Video Call Session
                                </button>
                                <!-- <button v-show="isTwilioJoined" class="btn btn-danger" @click="endVideoCall">End Video Call Session</button> -->
                            </twilio-video>
                        </div>

                        <button
                            @click="endSession"
                            class="btn btn-primary btn-primary-insv"
                            type="button"
                        >End Video Call Session</button>
                        <!-- <router-link :to="{
                            'name': 'user-consultation-list',
                            }"
                            class="btn btn-primary btn-primary-insv">
                            End Session
                        </router-link>-->

                        <div class="mt-5">
                            <data-access-permissions></data-access-permissions>
                        </div>
                    </div>

                    <div v-else>
                        <div class="card mb-5">
                            <div class="card-body">
                                <div v-if="consultation.type===2">
                                    <h5 class="mb-3">Medicine Charges</h5>
                                    <div class="d-flex align-items-center mb-3">
                                        <div class="mr-2">
                                            <b>Status:</b>
                                        </div>
                                        <span
                                            class="badge text-nowrap"
                                            :class="getMedicineChargesBadgeClass(consultationNoPharmacy.status)"
                                        >{{getMedicineChargesStatus(consultationNoPharmacy.status)}}</span>
                                    </div>
                                    <doctor-consultation-price
                                        ref="doctorConsultationPrice"
                                        :isConsultationInProgress="false"
                                        v-model="consultationNoPharmacy.doctorConsultationPriceList"
                                        :totalPrice="consultationNoPharmacy.consultationItemTotalPrice"
                                    ></doctor-consultation-price>

                                    <router-link
                                        :to="{
                                        'name':  'user-consultation-medicine-delivery-detail',
                                        'params': {
                                            id: consultationId
                                        }
                                    }"
                                        class="btn btn-primary btn-primary-insv"
                                    >View Payment Details</router-link>
                                </div>

                                <div v-else class="mb-5">
                                    <h5 class="mb-3">Medication Details</h5>
                                    <div>
                                        <prescription-detail
                                            :isEdit="false"
                                            v-model="prescriptionList"
                                            :pharmacyId="pharmacyId"
                                        ></prescription-detail>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-5">
                            <h5 class="mb-3">Consultation Details</h5>
                            <div>
                                <label>Doctor Comments</label>
                                <div class="card">
                                    <div class="card-body">
                                        <div v-html="doctorComments"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-5">
                            <h5 class="mb-3">Doctor Advice</h5>
                            <div>
                                <div class="mb-3">
                                    <label>Diet Advice</label>
                                    <div class="card">
                                        <div class="card-body">
                                            <div v-html="doctorDietAdvice"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label>Exercise Advice</label>
                                    <div class="card">
                                        <div class="card-body">
                                            <div v-html="doctorExcerciseAdvice"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label>Lifestyle Advice</label>
                                    <div class="card">
                                        <div class="card-body">
                                            <div v-html="doctorLifestyleAdvice"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="shouldShowCovid19Form" class="tab-pane fade" id="covid19Questionnaire" role="tabpanel">
                <div class="tab-content-wrapper">
                    <questionnaire-covid19
                        ref="questionnaireCovid19"
                        :isNew="false"
                        :consultationId="consultationId"
                        :patientName="consultation.participantName"
                        :patientIcNumber="consultation.participantIcNumber"
                    ></questionnaire-covid19>
                </div>
            </div>
        </div>

        <popup-modal ref="popupConsultationEnded" :hasCloseButton="false" title="Thank You!">
            <template slot="content">
                <p>Many thanks for using our service.</p>
                <template v-if="isCompanyUser">
                    <p>Your medicine will be paid by company, if credit balance remains sufficient, and personal benefit limit is also not exceeded.</p>
                    <p>Please move to Dashboard and check "Medicine Delivery Status".</p>
                </template>
                <template v-else>
                    <p>An email will be sent to you for paying the cost of your medicine(s), should any medicine is prescribed by doctor during video consultation.</p>
                    <p>Please move to "Medicine Delivery" under "Dashboard" page and make payment after receiving pricing of required medications.</p>
                </template>
            </template>
            <template slot="footer">
                <button
                    @click="moveToDashboardPage"
                    class="btn btn-primary btn-primary-insv"
                >Move to Dashboard Page</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import {
    replaceLineBreakInHtml,
    constructPrescriptionList
} from '@/utilities';

import {
    doctorConsultationNoPharmacyPrescriptionStatus,
    getEnumDisplay,
    getEnumBadgeClass
} from '@/config/enums';
import appointmentDetail from '@/components/appointment-detail';
import prescriptionDetail from '@/components/prescription';
import twilioVideo from '@/components/twilio-video';
import doctorConsultationPrice from '@/components/doctor-consultation-price';
import questionnaireCovid19 from '@/components/questionnaires/covid-19';
import dataAccessPermissions from '@/components/data-access-permissions';
export default {
    'components': {
        appointmentDetail,
        prescriptionDetail,
        twilioVideo,
        doctorConsultationPrice,
        popupModal,
        questionnaireCovid19,
        dataAccessPermissions
    },
    'computed': {
        shouldShowCovid19Form () {
            return this.$store.state.shouldShowCovid19Form;
        },
        isCompanyUser () {
            return this.$store.state.user.isCompanyUser;
        },
        consultationId () {
            return this.$route.params.id;
        },
        doctorComments () {
            return this.form.c ? replaceLineBreakInHtml(this.form.c) : 'NIL';
        },
        doctorDietAdvice () {
            return this.form.da ? replaceLineBreakInHtml(this.form.da) : 'NIL';
        },
        doctorExcerciseAdvice () {
            return this.form.ea ? replaceLineBreakInHtml(this.form.ea) : 'NIL';
        },
        doctorLifestyleAdvice () {
            return this.form.la ? replaceLineBreakInHtml(this.form.la) : 'NIL';
        }
    },
    data () {
        return {
            'form': {
                'da': null,
                'ea': null,
                'la': null,
                'm': null,
                'ai': null,
                'c': null
            },
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'participantIcNumber': null,
                'doctorName': null,
                'type': 0,
                'doctorHospitalOrClinic': ''
            },
            'consultationNoPharmacy': {
                'status': 0,
                'doctorConsultationPriceList': [],
                'consultationItemTotalPrice': 0
            },
            'consultationStatus': 0,
            'twilioToken': null,
            'twilioRoomName': null,
            'isTwilioLoading': true,
            'isTwilioStarted': false,
            'isTwilioJoined': false,
            'twilioStatus': null,
            'startVideoText':
                'Please click "Join Video Call Session" to join video call with doctor.',
            'waitingVideoText': 'Waiting for doctor to connect...',
            'isVideoCallEnded': false,
            'prescriptionList': [],
            'pharmacyId': ''
        };
    },
    mounted () {
        let id = this.$route.params.id;

        if (id) {
            this.axios
                .get('Consultation/GetConsultationDetails', {
                    'params': {
                        'consultationId': id
                    }
                })
                .then(({ data }) => {
                    let consultation = data.data;

                    this.consultation.startTime = consultation.st;
                    this.consultation.consultationId = consultation.cis;
                    this.consultation.participantName = consultation.u
                        ? consultation.u.fn
                        : null;
                    this.consultation.participantIcNumber = consultation.cp
                        ? consultation.cp.icn
                        : null;
                    this.consultation.doctorName = consultation.d
                        ? consultation.d.n
                        : null;
                    this.consultation.doctorHospitalOrClinic = consultation.d
                        ? consultation.d.dhca
                        : null;

                    this.consultation.type = consultation.ct;

                    if (
                        this.consultation.type === 2 &&
                        consultation.cnpd &&
                        consultation.cnpd.ps &&
                        consultation.cnpd.ps.psi
                    ) {
                        this.consultationNoPharmacy.doctorConsultationPriceList = consultation.cnpd.ps.psi.map(
                            item => ({
                                'type': item.in,
                                'name': item.id,
                                'price': item.ip
                            })
                        );
                        this.consultationNoPharmacy.consultationItemTotalPrice =
                            consultation.cnpd.ps.am;

                        this.consultationNoPharmacy.status =
                            consultation.cnpd.s;
                    }

                    this.consultationStatus = consultation.cs;

                    this.form.da = consultation.da;
                    this.form.ea = consultation.ea;
                    this.form.la = consultation.la;
                    this.form.m = consultation.m;
                    this.form.ai = consultation.ai;
                    this.form.c = consultation.c;

                    this.initializePrescriptionList(consultation.p);
                })
                .catch(() => {});
        }
    },
    beforeRouteLeave (to, from, next) {
        if (
            this.consultationStatus === 2 &&
            this.isTwilioStarted &&
            !this.isVideoCallEnded
        ) {
            const answer = window.confirm(
                'Do you really want to leave this page? Your video call session will be disconnected.'
            );
            if (answer) {
                this.endVideoCall().then(() => {});
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    'methods': {
        initializePrescriptionList (prescription) {
            this.pharmacyId = prescription.pi;
            if (prescription && prescription.pil) {
                this.prescriptionList = constructPrescriptionList(prescription.pil);
            }
        },
        startVideoCall () {
            this.twilioStatus = 'Connecting to video call...';
            this.isTwilioStarted = true;

            if (this.consultationId != null) {
                this.axios
                    .get('Consultation/GetTwilioRoom', {
                        'params': {
                            'consultationId': this.consultationId
                        }
                    })
                    .then(({ data }) => {
                        this.twilioToken = data.data.t;
                        this.twilioRoomName = data.data.n;

                        this.$nextTick(() => {
                            this.$refs.twilioVideo.startTwilio();
                        });
                    })
                    .catch(() => {
                        this.isTwilioStarted = false;
                    });
            }
        },
        endVideoCall () {
            if (this.isTwilioJoined) {
                return this.axios
                    .get('Consultation/EndTwilioSession', {
                        'params': {
                            'consultationId': this.consultationId
                        }
                    })
                    .finally(() => {
                        this.isTwilioJoined = false;
                        return new Promise((resolve, reject) => {
                            resolve();
                        });
                    });
            } else {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            }
        },
        endSession () {
            this.endVideoCall().then(() => {
                this.$refs.popupConsultationEnded.show();
            });
        },
        moveToDashboardPage () {
            this.$refs.popupConsultationEnded.hide().then(() => {
                this.$router.push({
                    'name': 'dashboard-user'
                });
            });
        },
        getMedicineChargesStatus (statusId) {
            return getEnumDisplay(
                doctorConsultationNoPharmacyPrescriptionStatus,
                statusId
            );
        },
        getMedicineChargesBadgeClass (statusId) {
            return getEnumBadgeClass(
                doctorConsultationNoPharmacyPrescriptionStatus,
                statusId
            );
        }
    }
};
</script>

<style>
</style>
